import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discount-group',
  templateUrl: './discount-group.component.html',
  styleUrls: ['./discount-group.component.css']
})
export class DiscountGroupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
